import { render, staticRenderFns } from "./LuExciseIssuesGrid.vue?vue&type=template&id=09c1ac13&"
import script from "./LuExciseIssuesGrid.vue?vue&type=script&lang=js&"
export * from "./LuExciseIssuesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports